<mat-form-field class="controls-alignment">
  <mat-label>{{field.labelName}}</mat-label>
  <input [ngxTimepicker]="defaultValue" [(ngModel)]="ngModelValue" matInput
    readonly [required]="isRequired" [disabled]="group.get(formValue).disabled"
    (keydown.backspace)="$event.preventDefault(); ngModelValue = null; group.get(formValue).setValue(null)"
    (keydown.delete)="$event.preventDefault(); ngModelValue = null; group.get(formValue).setValue(null)">

    <ngx-material-timepicker #defaultValue (timeSet)="updateValue($event)"></ngx-material-timepicker><br>
    @if (group.get(formValue).hasError('required')) {
      <mat-error>Time selection is required</mat-error>
    }
  </mat-form-field>